dcyAngular.internalDefine('classes/com/decisyon/core/socketMessages/handlerImpl/AbstractMessageHandler',["require","exports"],function(require,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=class{constructor(messageType){this.messageType=messageType}}});
//# sourceMappingURL=AbstractMessageHandler.js.map
;
